import { render, staticRenderFns } from "./ThePageTabs.vue?vue&type=template&id=3ad2e6a4&scoped=true"
import script from "./ThePageTabs.vue?vue&type=script&lang=js"
export * from "./ThePageTabs.vue?vue&type=script&lang=js"
import style0 from "./ThePageTabs.vue?vue&type=style&index=0&id=3ad2e6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad2e6a4",
  null
  
)

export default component.exports